var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsString, IsUUID } from 'class-validator';
import { CallPatientStatus } from '../enums/call-patient.enum.js';
export class UpdateCallPatientByTokenDto {
    patientId;
    inviteToken;
    status;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], UpdateCallPatientByTokenDto.prototype, "patientId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], UpdateCallPatientByTokenDto.prototype, "inviteToken", void 0);
__decorate([
    IsEnum(CallPatientStatus),
    __metadata("design:type", String)
], UpdateCallPatientByTokenDto.prototype, "status", void 0);
//# sourceMappingURL=update-call-patient-by-token.dto.js.map